// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".property-background[data-v-37f24b63]{background:linear-gradient(150deg,color-mix(in lch,var(--v-primary-base) 20%,#fff 80%) 0,color-mix(in lch,var(--v-secondary-base) 20%,#fff 80%) 60%)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
